import type { FaireProductEntity } from "../../entity_types/product";

export const p_zgbyjspukv: FaireProductEntity = {
  token: "p_zgbyjspukv",
  type: "product",
  name: "Women Head Planter",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl: "https://cdn.faire.com/fastly/257da1c839313e8192bc44acdab012d92e75543f03e4afb34e1c47777d519f2f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/915a32422485bd236f253127ab9fbdbd392c0290666a262203010c4ef82759b5.jpeg",
    "https://cdn.faire.com/fastly/7051ea650706cf53dab4456c826671fafd20d806141e335a799b3036873aa6fb.jpeg",
    "https://cdn.faire.com/fastly/ac8f8a8b01cd0f7019fc85c1ce83b4df95cea07b11b50ea9dc713ab95cb9e45a.jpeg",
    "https://cdn.faire.com/fastly/5edd351d0e6b6c11aaab0c58bba63f3c329c0662927135987eca8d3c7bd04679.jpeg",
    "https://cdn.faire.com/fastly/0ae5275195c607724ec827eb460d0af69f227ff27c2909dca17c2f6a6c32137b.jpeg",
    "https://cdn.faire.com/fastly/2fb54083074fac7a9e2d9f6681232dbe58b033ea2f8656c3c78696026a328054.jpeg",
    "https://cdn.faire.com/fastly/66fa244aec2820f85a9edff5f491cca5183b1722081c470889d37ac942e749ed.jpeg",
    "https://cdn.faire.com/fastly/b0f3b70e5b2e4ffc5c891b4dd46cf2899bcda204bd9a934347fd2331b7b98d24.jpeg",
    "https://cdn.faire.com/fastly/6f035b2dc4a29bf2249ccfcf0e325f3f435b2c9103d41234e2582a2da22b85ca.jpeg",
    "https://cdn.faire.com/fastly/8082fc75d155f3806734e140061fbc0303968b7ee48b64a58f00ebe90b263ceb.jpeg",
    "https://cdn.faire.com/fastly/679fd76806bf15521a2ed04c926671d155d2e9d0ed1e2251a488312a6b1e2db0.jpeg",
    "https://cdn.faire.com/fastly/7bf75632e8ff4d6d4605fbefbb3f89f7dae3475301a47baf2a4df1a4363e0d7e.jpeg",
    "https://cdn.faire.com/fastly/c7d21193981426154dcff1926b6a53c4833ae8384ae1a425bc97af96e7a964f0.jpeg",
    "https://cdn.faire.com/fastly/2dcaaceaf5e25a9a303d0c94e3b8ef86aa6949ad465e2a4fdd2e55dced586e88.jpeg"
  ],
  priceDollars: 11.5,
  description: "Give even the tiniest plants, flowers, or succulents a majestic home with this woman's head planter. Crafted out of cement, this gorgeous planter features lots of beautiful detail inspired by classic Greek and Roman sculpture. Available in extra-small (6.5\"H), small (8.5\"H) and large (10\"H) sizes — plus a wall planter.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:11.412Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
